module.exports = __webpack_public_path__ + "img/iphone-aoty-2018-dark_cn.5a17e39.svg";